// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { ResponseMessageSchema, StatusSchema, UuidSchema } from "./utilitySchemas";

export const PropertySchema = z.object({
  id: UuidSchema,
  type: z.string().min(1, { message: "Property type is required" }),
  streetName: z.string().min(1, { message: "Street name is required" }),
  streetNumber: z.string().min(1, { message: "Street number is required" }),
  postalCode: z.string().min(1, { message: "Postal code is required" }),
  city: z.string().min(1, { message: "City is required" }),
  country: z.string().default("germany"),
  description: z.string().min(1, { message: "Description is required" }),
  moreInfo: z.string().optional(),
  entryType: z.string().optional(),
  latitude: z.number().nullable().optional(),
  longitude: z.number().nullable().optional(),
  formattedAddress: z.string().nullable().optional(),
  geocodingProvider: z.string().nullable().optional(),
  geocodingProviderId: z.string().nullable().optional(),
  geocodingMetadata: z.unknown().nullable().optional(),
  coordinatesVerifiedAt: z.date().or(z.string()).nullable().optional(),
  locationEntryMode: z.enum(["verified", "manual"]).optional(),
});

export type Property = z.infer<typeof PropertySchema>;

export const CreatePropertySchema = PropertySchema.omit({ id: true });
export type CreateProperty = z.infer<typeof CreatePropertySchema>;

export const UpdatePropertySchema = PropertySchema.omit({ id: true }).partial();
export type UpdateProperty = z.infer<typeof UpdatePropertySchema>;

export const PropertiesResponseSchema = z.object({
  status: StatusSchema,
  message: ResponseMessageSchema,
  data: z.array(PropertySchema.omit({ description: true,moreInfo: true }).extend(
    {
      description: z.string().nullable(),
      moreInfo: z.string().nullable(),
    }
  )),
});
